// https://github.com/renatorib/react-powerplug/
// right now has some bugs at @babel/runtime
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
var noop = function () { };
var Value = /** @class */ (function (_super) {
    __extends(Value, _super);
    function Value() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.initial,
        };
        _this._set = function (updater, cb) {
            if (cb === void 0) { cb = noop; }
            var _a = _this.props.onChange, onChange = _a === void 0 ? noop : _a;
            _this.setState(typeof updater === 'function'
                ? function (state) { return ({ value: updater(state.value) }); }
                : { value: updater }, function () {
                onChange(_this.state.value);
                cb();
            });
        };
        _this._reset = function (cb) {
            if (cb === void 0) { cb = noop; }
            _this._set(_this.props.initial, cb);
        };
        return _this;
    }
    Value.prototype.render = function () {
        return this.props.children({
            value: this.state.value,
            set: this._set,
            reset: this._reset,
        });
    };
    return Value;
}(React.Component));
export { Value };
export var Toggle = function (_a) {
    var _b = _a.initial, initial = _b === void 0 ? false : _b, onChange = _a.onChange, props = __rest(_a, ["initial", "onChange"]);
    return (React.createElement(Value, { initial: initial, onChange: onChange }, function (_a) {
        var value = _a.value, set = _a.set, reset = _a.reset;
        return props.children({
            on: value,
            set: function (value) { return set(value); },
            reset: reset,
            toggle: function () { return set(function (on) { return !on; }); },
            setOn: function () { return set(true); },
            setOff: function () { return set(false); },
        });
    }));
};
//# sourceMappingURL=Value.js.map